import '../styles/highlight-markdown.scss';

// @ts-ignore TS7016
import hljs from 'highlight.js/lib/core';
// @ts-ignore TS7016
import bash from 'highlight.js/lib/languages/bash';
// @ts-ignore TS7016
import ini from 'highlight.js/lib/languages/ini';
// @ts-ignore TS7016
import javascript from 'highlight.js/lib/languages/javascript';
// @ts-ignore TS7016
import json from 'highlight.js/lib/languages/json';
// @ts-ignore TS7016
import shell from 'highlight.js/lib/languages/shell';

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('ini', ini);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('json', json);
hljs.registerLanguage('shell', shell);

const CODE_ELEMENTS_SELECTOR = 'pre code';

const HighlightMarkdown = {
  highlightAll: (): void => {
    HighlightMarkdown.highlightAllUnder(document);
  },
  highlightAllUnder: (node: ParentNode): void => {
    const codeElements = node.querySelectorAll<HTMLElement>(
      CODE_ELEMENTS_SELECTOR
    );
    codeElements.forEach((block) => {
      hljs.highlightBlock(block);
    });
  },
};

export default HighlightMarkdown;
